import * as React from 'react';

import AIBot from 'src/images/ai-bot.svg';
import css from './bot-dialog.css';


export type BotDialogProps = {
  onOk: () => Promise<void>;
};
export const BotDialog = ({onOk}: BotDialogProps) => (
  <div className={css.container}>
    <h3 className={css.title}>Hey there, Are you a robot ?</h3>
    <AIBot />
    <h4 className={css.info}>
      Please confirm that you are not robot by clicking below
    </h4>
    <button type="button" className={css.acceptButton} onClick={onOk}>
      No, I am not a robot
    </button>
  </div>
);
